import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'

/**
 * Главная может быть не портретная.
 * Поэтому сначала, главную, потом все портретные, и затем все остальные5
 */
export const usePhotosNext = (photos?: GQLPhotoItemFragment[]) => {
  if (photos && photos.length > 0) {
    const main = photos.filter(({ main }) => main)
    const portrait = photos.filter(({ portrait, main }) => portrait && !main)
    const rest = photos.filter(({ portrait }) => !portrait)

    /** Фото, которые будут на анкете */
    const showPhotos = [...main, ...portrait]
    const mainPhotos = showPhotos.slice(0, 4)

    /** Фото которые будут под подложкой еще +n фото */
    const restPhotos = [...showPhotos.slice(4), ...rest]

    return {
      mainPhotos,
      restPhotos,
    }
  }

  return {
    mainPhotos: [],
    restPhotos: [],
  }
}
